import {createContext} from 'react';

// Live elapsed/duration for the redesigned player panel's transport,
// status strip, and turns list. Split out from VideoPlayerStateContext so
// its ~5x/second updates (piggybacked on Audio.js's existing playback
// poll) don't re-render unrelated consumers of that context, like Video.js.
const PlaybackTimeContext = createContext({
  currentTime: 0,
  duration: 0,
  setPlaybackTime: () => {}
});

export default PlaybackTimeContext;
